import Link from 'components/ui/AppLink';
import { Box } from '@mui/material';
import React, { FC, useState } from 'react';

import UpdateCardDialog from '../../ui/UpdateCardDialog';

export interface UpdateCardButtonProps {
    subscriptionId: string;
    align?: 'center' | 'left';
    colorType?: 'primary' | 'secondary';
    linkClassName?: string;
    onStripeCardUpdated: () => void;
}

export const UpdateCardButton: FC<UpdateCardButtonProps> = ({
    subscriptionId,
    align = 'center',
    linkClassName,
    onStripeCardUpdated,
}) => {
    const [isUpdateCardDialogVisible, setIsUpdateCardDialogVisible] =
        useState(false);

    const onClick = () => {
        setIsUpdateCardDialogVisible(true);
    };

    return (
        <>
            <UpdateCardDialog
                subscriptionId={subscriptionId}
                isDialogOpen={isUpdateCardDialogVisible}
                closeDialog={() => setIsUpdateCardDialogVisible(false)}
                onStripeCardUpdated={onStripeCardUpdated}
            ></UpdateCardDialog>
            <Box
                sx={
                    align === 'center'
                        ? {
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                              flexDirection: 'column',
                          }
                        : undefined
                }
            >
                <Link onClick={onClick} className={linkClassName}>
                    <strong>Edit payment details</strong>
                </Link>
            </Box>
        </>
    );
};
